import React from 'react'

export const Logo = (props) => {
    return (
        <img height='140%' {...props} src={'./logo/logo.webp'} alt=''/>

    )
}
